import type { HistoryEntry } from '@/types/api';

/** The kind of edit a history entry describes, from its description's leading verb. */
export function editKind(description: string): string {
  const d = (description || '').trim();
  const rules: [RegExp, string][] = [
    [/^Auto-assigned/i, 'Auto-assign'],
    [/^Re-assigned/i, 'Re-assign'],
    [/^Added/i, 'Add officer'],
    [/^Removed/i, 'Remove officer'],
    [/^Restored/i, 'Restore officer'],
    [/^Swapped/i, 'Swap'],
    [/^Moved/i, 'Move'],
    [/^Deleted|^Cleared|^Nothing to clear/i, 'Clear / delete'],
  ];
  for (const [re, kind] of rules) if (re.test(d)) return kind;
  return d ? 'Other' : 'Unknown';
}

const csvCell = (v: string) => `"${(v ?? '').replace(/"/g, '""')}"`;

/** CSV of one row per roster edit: time, kind of edit, and the full description. */
export function editLogCsv(history: HistoryEntry[]): string {
  const rows = ['edit_no,timestamp,kind,description'];
  history.forEach((h, i) => rows.push(`${i},${csvCell(h.timestamp)},${editKind(h.description)},${csvCell(h.description)}`));
  return rows.join('\n') + '\n';
}

export function downloadEditLog(history: HistoryEntry[], sessionId: string): void {
  const blob = new Blob([editLogCsv(history)], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `edit-log-${sessionId || 'session'}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
